import { deserializeMergeFieldTokens, serializeMergeFieldTokens } from '@levitate/rich-text';
import * as Api from '@ViewModels';
import { createContentStateWithHtmlStringValue } from '@Models/utils/richContentUtils';
import { MEETING_MERGE_FIELD_TOKENS } from './meetingMergeFields';

/** Paragraph block style the legacy meeting editor stamped (mirrors BasicInfo's value). */
export const MEETING_NOTE_BLOCK_STYLE = 'margin:0;padding:0;font-size:14px;font-family:arial,sans-serif;';

/**
 * Stored meeting note (`<lev-content>`-wrapped HTML with raw `{{...}}` tokens) -> tiptap editor
 * HTML: unwrap the root element, then turn known raw tokens into merge-field pill markers.
 */
export function meetingStateToEditorHtml(contentState: Api.IRichContentEditorState): string {
	const inner = Api.getContentHtmlStringValueFromRawRichTextContentState(contentState.getRawRichTextContent()) ?? '';
	return deserializeMergeFieldTokens(inner, MEETING_MERGE_FIELD_TOKENS);
}

/**
 * tiptap editor HTML -> stored meeting note: collapse pill markers back to their literal `{{...}}`
 * tokens (legacy `data-placeholder` contact spans pass through), then re-wrap in `<lev-content>`.
 */
export function editorHtmlToMeetingState(editorHtml: string): Api.IRichContentEditorState {
	return createContentStateWithHtmlStringValue(serializeMergeFieldTokens(editorHtml));
}
